import { cn } from 'noddi-ui-common';
import { PropsWithChildren } from 'react';

export const TransparentBottomBar = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return (
    <div className={cn('fixed inset-x-0 bottom-0 p-4 shadow-lg md:static md:mt-5 md:p-0 md:shadow-none', className)}>
      {children}
    </div>
  );
};
